import { HourRange, GroupedRecords } from "./calendar";
import React, { useEffect, useRef } from 'react';

// Define the props for ScheduleWeekView
interface ScheduleWeekViewProps {
	dataSet: any[];
	hourHeight: number;
	startingHour: string;
	endingHour: string;
	showDayView: (date: string | Date) => void;
	handleAvailabilityClick: (record: any) => void;
	handleEntryClick: (record: any) => void;
}

const ScheduleWeekView: React.FC<ScheduleWeekViewProps> = (props) => {
	const {
		dataSet,
		hourHeight,
		startingHour,
		endingHour,
		showDayView,
		handleAvailabilityClick,
		handleEntryClick,
	} = props;

	const scope = 'week';
	const setTimeSlotsHeight = hourHeight * 24;

	const holidayBlock = (
		<div className="times-group holiday-block">
			<strong className="holiday-label">Holiday</strong>
		</div>
	);

	const dataColumns = dataSet.map((day, index) => {
		return (
			<div
				className={`times-cols${day.suppressed ? ' suppressed' : ''}${day.holiday !== null && day.holiday !== undefined ? ' holiday' : ''}`}
				key={index}
			>
				{day.holiday !== null && day.holiday !== undefined && holidayBlock}
				{day.availability
					&& Date.parse(day.date) >= Date.parse(new Date().toLocaleDateString('fr-CA'))
					&& (
						<GroupedRecords
							dataType={'availability'}
							records={day.availability}
							hourHeight={hourHeight}
							startingHour={startingHour}
							showDayView={showDayView}
							onRecordClick={handleAvailabilityClick}
						/>
					)}
				{day.entries && (
					<GroupedRecords
						dataType={'entries'}
						records={day.entries}
						hourHeight={hourHeight}
						startingHour={startingHour}
						showDayView={showDayView}
						onRecordClick={handleEntryClick}
					/>
				)}
			</div>
		);
	});

	const setStartingScrollPosition = hourHeight * 7;
	const scrollElement = useRef<HTMLDivElement>(null);

	const scrollToStartingPosition = () => {
		if (scrollElement.current) {
			scrollElement.current.scrollTop = setStartingScrollPosition;
		}
	};

	useEffect(() => {
		scrollToStartingPosition();
	}, []);

	return (
		<main>
			<section className="calendar week-view">
				<div className="calendar-body" ref={scrollElement}>
					<HourRange
						startHour={'2024-01-01T' + startingHour}
						endHour={'2024-01-01T' + endingHour}
						hourHeight={hourHeight}
						scope={scope}
					/>
					<div className="time-slots" style={{ height: setTimeSlotsHeight }}>{dataColumns}</div>
				</div>
			</section>
		</main>
	);
};

export default ScheduleWeekView;